export const STEAM_URL = "https://store.steampowered.com/app/2987350?utm_source=website"
export const X_URL = "https://x.com/PlayCatly"
export const IWATCH_URL = "https://apps.apple.com/us/app/catly-your-wrist-buddy/id6737467506"